﻿import { api } from '@cwd/lib/main';

export interface ContactCountRequest {
    inactiveMonths: number;
}

export interface BackgroundOperationResponse {
    RequestId: string;
    OperationType: string;
}

export async function startContactCount(request: ContactCountRequest): Promise<BackgroundOperationResponse> {
    return api.post('/BackgroundOperations/contacts/count', request);
}

export async function countInactiveContacts(inactiveMonths: number): Promise<number> {
    return api.get('/datamanagement/CountInactiveContacts?inactiveMonths=' + inactiveMonths);
}

export async function anonymizePeriod(inactiveMonths: number): Promise<void | Response> {
    return api.post('/datamanagement/anonymizeInactiveContacts?inactiveMonths=' + inactiveMonths);
}

export async function countDuplicates(): Promise<number> {
    return api.get('/datamanagement/CountDuplicateContacts');
}

export interface DuplicateContact {
    Email: string;
    Contacts: DuplicateContactSummary[];
}

export interface DuplicateContactSummary {
    ContactId: string;
    ExternalId: string;
    Email: string;
    SmsNumber: string;
    Created: Date;
    LastModified: Date;
}

export interface ContactCountResult {
    RequestId: string;
    InactiveMonths: number;
    ContactCount: number;
    Success: boolean;
    Status: string;
    ErrorMessage?: string;
    ExecutionTime: string;
}

const pageSize = 25;
export async function listDuplicates(skip: number, filterEmail: string): Promise<{ Count: number; Results: DuplicateContact[] }> {
    let searchString = '';
    !!filterEmail && (searchString = "&$filter=startswith(Email,'" + filterEmail + "')");
    return api.get('/datamanagement/DuplicateContacts?$inlinecount=allpages&$top=' + pageSize + '&$skip=' + skip + searchString);
}

export async function startDuplicateMerge(): Promise<void | Response> {
    return api.post('/datamanagement/MergeDuplicateContacts');
}

export async function mergeSingleContact(contact: DuplicateContact): Promise<void | Response> {
    return api.post('/datamanagement/MergeSingleContact', contact);
}
